import { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Button, SubTitle } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Row, Spinner } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import { RiEditFill } from "react-icons/ri";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
import EditPageModal from "../../Components/Modals/EditPageModal.js";
import {
  useDeletePageMutation,
  useGetAllPageQuery,
} from "../../Data/services/pageApi.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
// import { useDeleteReportTypeMutation } from "../../Data/services/reportTypeApi.js";

const PageManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  // const data = [
  //   {
  //     id: 2,
  //     slug: "terms-conditions",
  //     title: "Terms And Conditions",
  //     content: "Lorem epsum",
  //     url: "https://trangotech.com/privacy-policy-terms-of-service/",
  //   },
  //   {
  //     id: 1,
  //     slug: "privacy-policy",
  //     title: "Privacy Policy",
  //     content: "Lorem epsum",
  //     url: "https://trangotech.com/privacy-policy-terms-of-service/",
  //   },
  // ];

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllPageQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        limit: pageSize,
        page: currentPage,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);
    }
  }, [data]);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [deletePage, { isLoading: isDeleting }] = useDeletePageMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deletePage(slug);
      if (data.code === 200) {
        await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "title",
      text: "Title",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      style: {
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
    },
    {
      dataField: "url",
      text: "URL",
      sort: true,
      headerStyle: {
        width: "400px",
      },
      style: {
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
    },
    // {
    //   dataField: "order",
    //   text: "Order",
    //   sort: true,
    //   headerStyle: {
    //     width: "80px",
    //   },
    //   style: {
    //     textAlign: 'center',
    //     whiteSpace: "normal",
    //     wordBreak: "break-word",
    //   },
    // },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "150px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        // if (row.slug) {
        return (
          <div className="d-flex justify-content-center align-items-center ">
            <ToolTip placement={"top"} content={"Edit"}>
              <div
                className={` d-flex justify-content-center align-items-center rounded-3 mx-2 p-2 bg-primary-hover `}
                role="button"
                onClick={() => {
                  setEditedData(row);
                  handleEditModalOpen(true);
                }}
              >
                <span
                  className={`align-items-center d-flex justify-content-center`}
                >
                  <RiEditFill />
                </span>
                {/* <span>Edit</span> */}
              </div>
            </ToolTip>

            <ToolTip placement={"top"} content={"Delete"}>
              <div
                className="d-flex justify-content-center align-items-center bg-danger-hover rounded-3 p-2 mx-2 "
                role="button"
                onClick={() => {
                  setEditedData(row);
                  handleDeleteModalOpen();
                }}
              >
                <span className={`d-flex align-items-center`}>
                  <MdDeleteForever />
                </span>
                {/* <span>Delete</span> */}
              </div>
            </ToolTip>
          </div>
        );
        // },
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditPageModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Policy Documents Management"} classes="text-black" />
        </div>

        {
          <Row>
            <Col md={12}>
              <Button
                classes={`${styles.cardBtn} `}
                text="Add Page"
                onClick={handleAddUser}
              ></Button>
            </Col>
          </Row>
        }
      </div>

      <div
        className={`${styles.mainTable} ${
          dataFetched && isFetching ? "blur-table" : ""
        }`}
      >
        {!dataFetched || !isSuccess ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            {
              <Table
                data={rowData || []}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords} // todo
                totalPages={totalPages} // todo
                pageSize={pageSize} // todo
                currentPage={currentPage} // todo
                setCurrentPage={setCurrentPage} // todo
                setPageSize={setPageSize} // todo
                refetch={refetch} // todo
                // refetch={() => {}} // todo
              />
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default PageManagementScreen;
